








import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { ICompany } from '../api/company.interface';
import CompanyToolbar from './CompanyToolbar.vue';
import CompanyTable from './CompanyTable.vue';
import CompanyDialog from './CompanyDialog.vue';
import { CompanyEventBus, GET_COMPANIES } from '../api/company.event';

@Component({
  name: 'companies',
  components: {
    CompanyToolbar,
    CompanyTable,
    CompanyDialog,
  },
})
export default class Companies extends Vue {
  // Lifecycle Functions
  mounted() {
    if (this.dirty) {
      CompanyEventBus.$emit(GET_COMPANIES);
    }
  }

  // Getters
  @Getter('auth/authStatus')
  authStatus: string;
  @Getter('company/dirty')
  dirty: boolean;

  // Watchers
  @Watch('authStatus')
  authState() {
    if (this.authStatus == 'Success') CompanyEventBus.$emit(GET_COMPANIES);
  }
}
